export default __webpack_public_path__ + "static/media/TSC-button.568b096d.png";